export const screens = {
  HOME: 'HOME',
  ECOSYSTEM: 'ECOSYSTEM',
  SEND: 'SEND',
  MULTISEND: 'MULTISEND',
  MULTISENDDETAIL: 'MULTISENDDETAIL',
  MULTISENDCONFIRM: 'MULTISENDCONFIRM',
  RECEIVE: 'RECEIVE',
  SETTING: 'SETTING',
  NFT: 'NFT',
  NFTDETAIL: 'NFTDETAIL',
  NFTTRANSFER: 'NFTTRANSFER',
  NFTTRANSFERPREVIEW: 'NFTTRANSFERPREVIEW',
  TOKEN: 'TOKEN',
  ACTIVITY: 'ACTIVITY',
  TOKENINDEX: 'TOKENINDEX',
  TOKENDETAIL: 'TOKENDETAIL',
  NEROTOKENDETAIL: 'NEROTOKENDETAIL',
  SENDUSEROP: 'SENDUSEROP',
} as const

export type Screen = (typeof screens)[keyof typeof screens]
